var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolume32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 6.00005V3.01782L14.1236 5.10876L8.03648 11.0943H4.68227C3.06283 11.0943 1.75 12.4071 1.75 14.0266V17.3911C1.75 19.0105 3.06282 20.3234 4.68227 20.3234H8.00416L14.0853 26.852L16.25 29.176V26V6.00005ZM9.42452 13.2356L13.75 8.98227V22.8241L9.46278 18.2214L9.09204 17.8234H8.5481H4.68227C4.44353 17.8234 4.25 17.6298 4.25 17.3911V14.0266C4.25 13.7878 4.44353 13.5943 4.68227 13.5943H8.5481H9.05972L9.42452 13.2356ZM19.2728 29.4384C25.8551 28.7988 30.9999 23.2502 30.9999 16.5C30.9999 9.74973 25.8551 4.20113 19.2728 3.56149V6.07634C24.4715 6.70455 28.4999 11.1318 28.4999 16.5C28.4999 21.8681 24.4715 26.2954 19.2728 26.9236V29.4384ZM19.2501 24.4027C23.0745 23.8025 25.9999 20.4928 25.9999 16.4998C25.9999 12.5069 23.0745 9.19716 19.2501 8.59695V11.1426C21.6854 11.7086 23.4999 13.8923 23.4999 16.4998C23.4999 19.1073 21.6854 21.291 19.2501 21.8571V24.4027Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume32);
export default __webpack_public_path__ + "static/media/volume-32.315b0b135bfe1c4ee8b97b8f0b88f227.svg";
export { ForwardRef as ReactComponent };